import { render, staticRenderFns } from "./TrapezSER.vue?vue&type=template&id=99deb656&"
import script from "./TrapezSER.vue?vue&type=script&lang=js&"
export * from "./TrapezSER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports